
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC } from "react";
import ADILiveChatComponent from "@NA/Components/ADILiveChatComponent";

const enum fields {
    checkboxFieldValue = "checkboxFieldValue",
}

interface Props extends WidgetProps {
    fields: {
        [fields.checkboxFieldValue]: boolean;
    };
}

const ADILiveChat: FC<Props> = props => {
    const { checkboxFieldValue } = props.fields

    return (
        <ADILiveChatComponent isFooter={checkboxFieldValue}/>
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};
  
const widgetModule: WidgetModule = {
    component: ADILiveChat,
    definition: {
        group: "Basic",
        fieldDefinitions : [
            {
                name: fields.checkboxFieldValue,
                displayName: "Footer",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                tab: basicTab
            }
        ],
        displayName: "ADI Live Chat",
    },
};

export default widgetModule;
